import React from 'react';
import styles from './style.module.scss';
import Image from '@/globalComponents/image';

export interface tabItemTextProps {
  classNames?: String;
  text: string;
  metaInfo?: any;
}

export const TabItemText = (props: tabItemTextProps) => {
  const { classNames, text, metaInfo } = props;

  const textClass = `text-lg md:text-xl md:font-normal whitespace-nowrap ${styles.iconText}`;

  const tabItemContainerClass = `flex justify-center gap-s2 pb-5 md:pb-5 px-6 ${classNames} cursor-pointer`;

  const imagecontainerClass = `relative justify-self-start w-14 md:w-20`;

  const imageClass = `absolute -top-1`;

  return (
    <div className={tabItemContainerClass} data-testid={text}>
      <p className={textClass}>{text}</p>
      {metaInfo && (
        <div className={imagecontainerClass}>
          <Image className={imageClass} src={metaInfo} alt={text} />
        </div>
      )}
    </div>
  );
};
